import { Outlet } from 'react-router';
import { AppLayout } from '@/layouts/app/app-layout';
import { useAuthorizedLayoutItems } from '@/layouts/app/use-authorized-layout-items';
import { useOrganizationService } from '@/providers/organization-service-provider';

export function DashboardLayout(): React.ReactElement {
  const { headerItems, footerItems } = useAuthorizedLayoutItems();
  const organizationService = useOrganizationService();
  return (
    <AppLayout headerItems={headerItems} footerItems={footerItems} organizationId={organizationService.organizationId}>
      <Outlet />
    </AppLayout>
  );
}
